/**
 * Curated language options — top languages relevant to the funkihoo
 * audience (launch markets per plan §Context).
 *
 * Each entry carries:
 *   value:      ISO-639-1 two-letter code (storage form)
 *   labelKey:   i18n key resolving to the English name
 *   nativeName: endonym in the language's own script (UI displays
 *               both, e.g. "Urdu (اردو)")
 *
 * No icons — language is a label; flag-emoji shorthand would conflate
 * language with country. (Urdu is spoken in many countries.)
 */

import type { TraitOption } from '../types.js';

export const LANGUAGE_OPTIONS: readonly TraitOption[] = [
  { value: 'en', labelKey: 'language.en', nativeName: 'English' },
  { value: 'ur', labelKey: 'language.ur', nativeName: 'اردو' },
  { value: 'ar', labelKey: 'language.ar', nativeName: 'العربية' },
  { value: 'tr', labelKey: 'language.tr', nativeName: 'Türkçe' },
  { value: 'fa', labelKey: 'language.fa', nativeName: 'فارسی' },
  { value: 'bn', labelKey: 'language.bn', nativeName: 'বাংলা' },
  { value: 'hi', labelKey: 'language.hi', nativeName: 'हिन्दी' },
  { value: 'pa', labelKey: 'language.pa', nativeName: 'ਪੰਜਾਬੀ' },
  { value: 'fr', labelKey: 'language.fr', nativeName: 'Français' },
  { value: 'de', labelKey: 'language.de', nativeName: 'Deutsch' },
  { value: 'es', labelKey: 'language.es', nativeName: 'Español' },
  { value: 'it', labelKey: 'language.it', nativeName: 'Italiano' },
  { value: 'pt', labelKey: 'language.pt', nativeName: 'Português' },
  { value: 'nl', labelKey: 'language.nl', nativeName: 'Nederlands' },
  { value: 'sv', labelKey: 'language.sv', nativeName: 'Svenska' },
  { value: 'ru', labelKey: 'language.ru', nativeName: 'Русский' },
  { value: 'id', labelKey: 'language.id', nativeName: 'Bahasa Indonesia' },
  { value: 'ms', labelKey: 'language.ms', nativeName: 'Bahasa Melayu' },
  { value: 'sw', labelKey: 'language.sw', nativeName: 'Kiswahili' },
  { value: 'ha', labelKey: 'language.ha', nativeName: 'Hausa' },
  { value: 'so', labelKey: 'language.so', nativeName: 'Soomaali' },
  { value: 'bs', labelKey: 'language.bs', nativeName: 'Bosanski' },
  { value: 'sq', labelKey: 'language.sq', nativeName: 'Shqip' },
  { value: 'ps', labelKey: 'language.ps', nativeName: 'پښتو' },
  { value: 'ku', labelKey: 'language.ku', nativeName: 'Kurdî' },
  { value: 'az', labelKey: 'language.az', nativeName: 'Azərbaycanca' },
  { value: 'uz', labelKey: 'language.uz', nativeName: 'Oʻzbekcha' },
  { value: 'ta', labelKey: 'language.ta', nativeName: 'தமிழ்' },
  { value: 'te', labelKey: 'language.te', nativeName: 'తెలుగు' },
  { value: 'gu', labelKey: 'language.gu', nativeName: 'ગુજરાતી' },
  { value: 'mr', labelKey: 'language.mr', nativeName: 'मराठी' },
  { value: 'ml', labelKey: 'language.ml', nativeName: 'മലയാളം' },
] as const;

export const LANGUAGE_VALUES: ReadonlySet<string> = new Set(LANGUAGE_OPTIONS.map((o) => o.value));
